module.exports = {"id":"230481","name":"Ronaldo Cabrais","rating":"76","photo":"./data/images/photos/1/230481.png","club":{"name":"Botafogo","logo":"./data/images/clubs/Botafogo.png"},"positions":["MOC","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RonaldoCabrais0.json
// module id = 3714
// module chunks = 0